const BLOG = "blog";

export const blogKeys = {
	article: (slug: string) => [BLOG, "article", slug] as const,
	create: [BLOG, "create"] as const,
	delete: [BLOG, "delete"] as const,
	list: [BLOG, "list"] as const,
	update: [BLOG, "update"] as const,
};
